// DO NOT EDIT -- generated from Go package fs/services/webber/internal/highlight

import * as clientapi from './fs_api_clientapi';


///////////
// Enums //
///////////

// ModalFieldType specifies the type of a user input field in the SendNote modal.
export enum ModalFieldType {
	FieldTypeEnum = "enum",
	FieldTypeText = "text",
	FieldTypeTextArea = "area",
	FieldTypeAutocomplete = "autocomplete",
	FieldTypeEnumWithDependents = "enumWithDependents"
}


///////////////
// Constants //
///////////////

export const Unused: number = 0;

/////////////
// Structs //
/////////////

// SendNoteReq is sent by client as JSON body of a SendNote request.
export interface SendNoteReq {
  IntegrationId: string;
  Note: clientapi.Note | null;
  Highlight: clientapi.Highlight | null;
  ModalFields: {[key: string]: string} | null;
}

// SendModalField specifies a field that can be displayed in the SendNote modal.
export interface SendModalField {
  Desc: string;
  Type: ModalFieldType;
  IsConfig: boolean;
  SortIndex: number;
  Enum: {[key: string]: string} | null;
  Required: boolean;
  Children: {[key: string]: SendModalField | null} | null;
}

// SendModal contains details of what to show in the SendNote modal dialog.
export interface SendModal {
  Fields: {[key: string]: SendModalField | null} | null;
  Values: {[key: string]: string} | null;
  DisallowConfigChange: boolean;
}

// SendNoteRsp is sent by server as JSON response to a SendNote request.
export interface SendNoteRsp {
  ErrorMsg: string;
  ModalRequired: boolean;
  Modal: SendModal | null;
  Url: string;
}
